import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { selectTileFieldsState } from "../../../../store/selectors/fieldsStateSelectors";
import { selectMeasures } from "../../../../store/selectors/metaDataSelectors";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks";
import { updateMeasureFields } from "../../utils/MeasureUtils";

const useTrackMeasuresListUpdate = () => {
  const dispatch = useAppDispatch();

  const measures = useSelector(selectMeasures);
  const fieldsState = useSelector(selectTileFieldsState);
  const fieldsStateRef = useRef(fieldsState);
  useEffect(() => {
    fieldsStateRef.current = fieldsState;
  }, [fieldsState]);

  useEffect(
    () =>
      updateMeasureFields(
        {
          fields: fieldsStateRef.current.fields,
          updateMeasureField: (field, changes) => dispatch(fieldsStateActions.updateMeasureField({ field, changes })),
          updateFieldConfig: (field, changes) => dispatch(fieldsStateActions.updateFieldConfig({ field, changes })),
          removeField: (field) => dispatch(fieldsStateActions.removeField(field)),
        },
        measures
      ),
    [measures, dispatch]
  );
};

export default useTrackMeasuresListUpdate;
